import { render, staticRenderFns } from "./KnGroupSucursals.vue?vue&type=template&id=6ea11d6e"
import script from "./KnGroupSucursals.js?vue&type=script&lang=js&external"
export * from "./KnGroupSucursals.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports